// extracted by mini-css-extract-plugin
export default {"root":"FormEventNew_root__SsRwo","firstRow":"FormEventNew_firstRow__HelVA"};